import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import api from '../../api';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Select } from '../../components/Common';
import { batteryTypeOptions, toBatteryTypeSelectValue } from '../../constants/batteryTypes';

// Lets an operator set/correct the battery manufacturer for a gateway. Chosen from a stable
// enum (for inverter-bundled setups the system only detects the inverter, not the battery),
// stored on the gateway as informational metadata via the gateway API.
const EditBatteryManufacturerModal = ({ deviceId, current, open, setOpen, onSaved }) => {
    const [manufacturer, setManufacturer] = useState(toBatteryTypeSelectValue(current));
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setManufacturer(toBatteryTypeSelectValue(current));
    }, [current, open]);

    const handleClose = () => {
        setOpen(false);
        setError('');
        setManufacturer(toBatteryTypeSelectValue(current));
    };

    const save = async () => {
        const trimmed = manufacturer.trim();
        if (trimmed === '') {
            setError('Please select a battery type.');
            return;
        }
        setError('');
        setSaving(true);
        try {
            const resp = await api.set_device_gateway_battery_manufacturer(deviceId, trimmed);
            const saved = resp?.data?.battery_manufacturer ?? trimmed;
            onSaved(saved);
            setOpen(false);
            toast.success('Battery manufacturer updated', {
                position: 'top-center',
                autoClose: 300,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (err) {
            setError(`Could not update battery manufacturer.\n${err}`);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <Popup open={open} onClose={handleClose} modal className="modal" contentStyle={{ maxWidth: 440, width: '90%', borderRadius: 15 }}>
                <div>
                    <button className="modal__close" onClick={handleClose}>
                        &#10005;
                    </button>
                    <h5 className="modal__header"> Battery manufacturer </h5>
                    <div className="modal__content" style={{ alignItems: 'stretch', textAlign: 'left', padding: '24px 28px 8px' }}>
                        <label htmlFor="batteryManufacturer" style={{ fontWeight: 600, marginBottom: 4 }}>
                            Battery type
                        </label>
                        <Select
                            id="batteryManufacturer"
                            value={manufacturer}
                            onChange={e => setManufacturer(e.target.value)}
                            options={batteryTypeOptions}
                            fullWidth
                        />
                        <p style={{ margin: '6px 0 0', fontSize: 13, color: '#6b7280' }}>The battery brand for inverter-bundled setups.</p>
                        {error !== '' && (
                            <p className="modal__error-message" style={{ marginTop: 8 }}>
                                {error}
                            </p>
                        )}
                    </div>

                    <div className="modal__actions">
                        <Button text={saving ? 'Saving…' : 'Save'} onClick={save} disabled={saving} />
                        <Button text="Cancel" onClick={handleClose} className="modal__cancel" />
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default EditBatteryManufacturerModal;
